module.exports = __webpack_public_path__ + "img/video_icon.218ebf79.svg";